import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Cue5050Service } from '../../_services/fundraising/cue5050.service';


@Component({
  selector: 'app-verify-ticket-modal',
  templateUrl: './choose-winning-ticket-modal.component.html',
  styleUrls: ['./choose-winning-ticket-modal.component.css']
})
export class ChooseWinningTicketModalComponent implements OnInit {

  public eventId;

  public ticketNumber: string;
  public referenceNumber: string;

  @Output() hasError = new EventEmitter();

  constructor(
    private cue5050Service: Cue5050Service,
    private bsModalRef: BsModalRef
  ) { }

  ngOnInit() { }

  verify() {
    this.cue5050Service.chooseWinner(this.eventId, this.ticketNumber, this.referenceNumber).subscribe(
      () => { 
        this.hasError.emit(false);
        this.bsModalRef.hide();
      },
      error => {
        this.hasError.emit(true);
        this.bsModalRef.hide();
      }
    );
  }

  close() {
    this.hasError.emit(false);
    this.bsModalRef.hide();
  }

}

